"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReducePositionDetailInfo = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const react_1 = require("react");
const GFReducePositionProcessor_1 = require("./GFReducePositionProcessor");
const useReducePositionDetailInfo = (params) => {
    const { reduce_num, checkInfo, exchangeOrder, symbolInfo } = params;
    const showRealData = (0, react_1.useMemo)(() => {
        return (checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.check_result) && new trade_utils_lib_1.SafeDecimal(reduce_num).gt(0);
    }, [checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.check_result, reduce_num]);
    const real_reduce_num_percent = (0, react_1.useMemo)(() => {
        if (!checkInfo || !checkInfo.max_reduce_num || new trade_utils_lib_1.SafeDecimal(checkInfo.max_reduce_num).eq(0)) {
            return "0";
        }
        const order = exchangeOrder.exchangeGridV4FuturesOrder;
        const perVolume = order === null || order === void 0 ? void 0 : order.per_volume;
        const maxPercent = new trade_utils_lib_1.SafeDecimal((0, GFReducePositionProcessor_1.calcPercentBasedOnNum)(perVolume, checkInfo.max_reduce_num, symbolInfo));
        const res = new trade_utils_lib_1.SafeDecimal((0, GFReducePositionProcessor_1.calcPercentBasedOnNum)(perVolume, reduce_num, symbolInfo));
        if (res.gt(maxPercent)) {
            return new trade_utils_lib_1.SafeDecimal(maxPercent).toFixed(2, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        }
        else {
            return res.toFixed(2, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        }
    }, [checkInfo, exchangeOrder.exchangeGridV4FuturesOrder, reduce_num, symbolInfo]);
    const [reduceAmount, reduceFee, reduceGridProfit, reduceInvestment, reducePnl, estLiqPriceUp, estLiqPriceDown, estLiqPriceUpAfter, estLiqPriceDownAfter, estDeltaPosition, estDeltaProfit, hasLoss,] = (0, react_1.useMemo)(() => {
        const reduce_amount = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_amount : "--";
        const reduce_fee = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_fee : "--";
        const reduce_gridprofit = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_gridprofit : "--";
        const reduce_investment = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_investment : "--";
        const reduce_pnl = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_pnl : "--";
        const estimate_liquidation_price_up = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up : "--";
        const estimate_liquidation_price_down = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down : "--";
        const estimate_liquidation_price_up_after = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up_after : "--";
        const estimate_liquidation_price_down_after = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down_after : "--";
        const estimate_delta_position = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position : "--";
        const estimate_delta_profit = showRealData ? checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_profit : "--";
        const hasLoss = new trade_utils_lib_1.SafeDecimal(estimate_delta_profit).lt(0);
        return [
            reduce_amount,
            reduce_fee,
            reduce_gridprofit,
            reduce_investment,
            reduce_pnl,
            estimate_liquidation_price_up,
            estimate_liquidation_price_down,
            estimate_liquidation_price_up_after,
            estimate_liquidation_price_down_after,
            estimate_delta_position,
            estimate_delta_profit,
            hasLoss,
        ];
    }, [
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_amount,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_fee,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_gridprofit,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_investment,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reduce_pnl,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up_after,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down_after,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position,
        checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_profit,
        showRealData,
    ]);
    return {
        real_reduce_num_percent,
        reduceAmount,
        reduceFee,
        reduceGridProfit,
        reduceInvestment,
        reducePnl,
        estLiqPriceUp,
        estLiqPriceDown,
        estLiqPriceUpAfter,
        estLiqPriceDownAfter,
        estDeltaPosition,
        estDeltaProfit,
        hasLoss,
    };
};
exports.useReducePositionDetailInfo = useReducePositionDetailInfo;
